import styled from 'styled-components'

export const Container = styled.div`
	display: grid;
	grid-template-columns: 1fr 0.2fr;
	gap: 12px;
	align-items: center;
	padding: 21px 0;

	label {
		font-weight: 500;
	}

	@media (max-width: 768px) {
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		gap: 21px;

		label {
			max-width: 100%;
		}
	}
`

export const ContainerRadio = styled.div`
	display: flex;
	width: 150px;
	justify-content: space-between;
	margin: 0;

	div {
		display: flex;
		margin: 0;
	}

	label {
		margin: 0;
	}
`
